import { NavigationViewAction, NavigationViewActionsNames } from "./actions";
import { INavigationViewState } from "./interfaces";

export const initialState: INavigationViewState = {
  items: {},
};

const navigationViewReducer = (
  state: INavigationViewState = initialState,
  action: NavigationViewAction
): INavigationViewState => {
  switch (action.type) {
    case NavigationViewActionsNames.SET_ITEM_BADGE: {
      const item = state.items[action.payload.itemId] || {};
      const { badge } = action.payload;

      return {
        ...state,
        items: {
          ...state.items,
          [action.payload.itemId]: { ...item, badge },
        },
      };
    }

    case NavigationViewActionsNames.CLEAR_ITEM_BADGE: {
      if (state.items[action.payload.itemId]) {
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { badge, ...item } = state.items[action.payload.itemId];
        return {
          ...state,
          items: {
            ...state.items,
            [action.payload.itemId]: item,
          },
        };
      }

      return state;
    }

    default:
      return state;
  }
};

export default navigationViewReducer;
